/**
 * RelativeTimeRangeSelector 组件
 * 用于选择相对时间范围的公共组件
 */

import React, { useState } from 'react';
import { useIntl } from "umi";
import { Dropdown } from 'tea-component';
import { IRelativeTimeRangeSelectorProps } from '../TimeCompare/types';
import { formatDateRange, getDateRange } from "@dbl/core/date";
import { LANGUAGE_EN } from "@home/_config/config";
import './index.scss';
import RelativeTimeOptions from "@/pages/datalab/components/DateComponents/RelativeTimeOptions";
import TimeRangeDisplay from "@/pages/datalab/components/DateComponents/TimeRangeDisplay";

const RelativeTimeRangeSelector: React.FC<IRelativeTimeRangeSelectorProps> = (props) => {
  const {
    baseTimeRange,
    timeGranularity,
    value,
    onChange,
    className = '',
    mountClassNames,
    dropdownProps,
  } = props;
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const { last_time: amount, is_custom: isSelectedCustom, granularity, name_en: nameEn, name_cn: nameCn } = value || {};
  
  // 在报表顶部日期筛选器中, RangePicker组件内部设置 点击日期浮窗外部就关闭日期浮窗的规则
  // 所以在日期浮窗内打开对比时间选择器的浮窗(挂载在body中, 不在日期浮窗内部) 就会关闭日期浮窗
  // 所以这里增加了个挂载节点的状态, 当打开对比时间选择器的浮窗时, 将浮窗挂载到内部, 避免点击关闭日期浮窗
  // 这个方案同时无需修改公共RangePicker组件的逻辑
  // 在其他场景调用时, 不传递mountClassNames, 在打开浮窗时不会触发更新状态
  const [mountNode, setMountNode] = useState<Element | null>(null);
  const range = getDateRange(baseTimeRange, {amount, granularity, timeGranularity});
  const timeRange = formatDateRange(range, timeGranularity);
  // rtrs 是relative-time-range-selector的缩写, 要不然类名太长了
  return (
    <div className={`dbl-relative-time-range-selector ${className}`}>
      <Dropdown
        clickClose={false}
        button={(<TimeRangeDisplay prefix={isEn ? nameEn : nameCn} timeRange={timeRange || []} granularity={timeGranularity} />)}
        appearance="button"
        // matchButtonWidth
        className={'dbl-rtrs-drop'}
        boxClassName={'dbl-rtrs-box'}
        popupContainer={mountNode}
        onOpen={() => {
          mountClassNames && !mountNode && setMountNode(document.querySelector(mountClassNames) as Element);
        }}
        onClose={() => {
          // 当选中了自定义选项, 但用户又没有输入值, 默认2
          if (isSelectedCustom && !amount) {
            const range = getDateRange(baseTimeRange, {amount: '2', granularity: timeGranularity, timeGranularity});
            onChange({
              name_cn: '自定义',
              name_en: 'Custom',
              is_custom: true,
              last_time: '2',
              granularity: timeGranularity,
              time_range: formatDateRange(range, timeGranularity),
            });
          }
        }}
        /* 不能被图表的浮窗遮盖 */
        overlayStyle={{zIndex: 999999999}}
        {...(dropdownProps || {})}
      >
        {
          (close) => (<RelativeTimeOptions
            baseTimeRange={baseTimeRange}
            amount={amount}
            granularity={granularity}
            timeGranularity={timeGranularity}
            isSelectedCustom={isSelectedCustom}
            onChange={(value, isClose) => {
              const { nameCn, nameEn, isSelectedCustom, granularity, amount} = value;
              onChange?.({
                name_cn: nameCn,
                name_en: nameEn,
                is_custom: isSelectedCustom,
                last_time: amount,
                granularity,
              });
              isClose && close();
            }}
          />)
        }
      </Dropdown>
    
    </div>
  );
};

export default RelativeTimeRangeSelector;